import { page_builder_origin } from "features/PageBuilders/PageBuilders.constants";
import { appendUrlParams } from "utils/urlUtils";

export const GJS_PAGE_BUILDER_ROUTE_KEYS = {
  update: "gjs-sales-page-builder-update",
};

export const GJS_PAGE_BUILDER_ROUTE_IDS = {
  [GJS_PAGE_BUILDER_ROUTE_KEYS.update]:
    "/gjs-sales-page-builder/:salePageUuid/update",
};

export const query_params = {
  template_uuid: "template",
};

export const GJS_PAGE_BUILDER_ROUTE_GENERATORS = {
  [GJS_PAGE_BUILDER_ROUTE_KEYS.update]: ({ salePageUuid, templateUuid }) =>
    appendUrlParams(`/gjs-sales-page-builder/${salePageUuid}/update`, {
      [query_params.template_uuid]: templateUuid,
    }),
};

/**
 * actions that the caqn be triggered from the page builder
 */
export const page_builder_action_keys = {
  listener_added: "listener-added",
  start_init: "start-init",
  save: "save",
  save_draft: "save-draft",
  auto_save: "auto-save",
  publish: "publish",
  upload_images: "upload-images",
  image_uploaded: "image-uploaded",
  media_library: {
    fetch_all: "media-library-fetch-all", // Fetch all data from media library
    fetched: "media-library-fetched", // Posts fetched media library data back to Page Builder
    get_preview_url: "get-preview-url", // Use to Fetch preview URL
    on_get_preview_url: "on-get-preview-url", // Posts Fetched Preview URL Data
  },
  notify: "notify",
};

export const page_builder_url = `${page_builder_origin}/sale`;
